import {Component, computed, input} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {DatePipe} from '@angular/common';
import {environment} from '@env/environment';


@Component({
  selector: 'app-product-badges',
  templateUrl: './product-badges.component.html',
  styleUrls: ['./product-badges.component.scss'],
  imports: [DatePipe]
})
export class ProductBadgesComponent {

  readonly product = input<WineProduct | null>();

  constructor() {
  }

  showStockText = computed(() => {
    const product = this.product();
    return product?.ctaLink && product.ctaStockText;
  });
  showPreorder = computed(() => {
    return !this.showStockText() && this.product()?.preorderDate;
  });
  showInStock = computed(() => {
    return !this.showStockText() && this.product()?.inStock && !this.showPreorder();
  });
  showOutOfStock = computed(() => {
    return !this.showStockText() && !this.product()?.inStock;
  });

  hideSupervinAdvantages = computed(() => {
    return this.product()?.hideSupervinAdvantages
  });

  showWineGuarantee = environment.locale === 'da-DK';

}
